import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';

const DropdownMenu = DropdownMenuPrimitive.Root;

const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

const DropdownMenuPortal = DropdownMenuPrimitive.Portal;

interface DropdownMenuContentProps extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Content> {
    hasBorder?: boolean;
    hasPadding?: boolean;
}

const DropdownMenuContent = React.forwardRef<
    React.ElementRef<typeof DropdownMenuPrimitive.Content>,
    DropdownMenuContentProps
>(({ className, align = 'start', sideOffset = 4, hasBorder = false, hasPadding = true, ...props }, ref) => (
    <DropdownMenuPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={`tw-z-[1050] tw-rounded tw-bg-fill-primary tw-text-popover-foreground tw-shadow-lg tw-outline-none
                    data-[state=open]:tw-duration-300 data-[state=open]:tw-ease-out
                    data-[state=closed]:tw-duration-100 data-[state=closed]:tw-ease-out
                ${hasBorder ? 'tw-border tw-border-solid tw-border-primary' : ''} ${hasPadding ? 'tw-p-4' : ''} ${className || ''}`
            .trim()}
        {...props}
    />
));

DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;

export { DropdownMenu, DropdownMenuContent, DropdownMenuPortal, DropdownMenuTrigger };
